import { render } from "./Profile.vue?vue&type=template&id=01fd1258&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=01fd1258&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-01fd1258"

export default script